var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"mb-0 border-0 rounded-0",attrs:{"show":_vm.show,"variant":"danger"}},_vm._l((_vm.errors),function(error){return _c('div',{key:error},[_vm._v(" "+_vm._s(error)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }